import { Features } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

export const usePicklistsFeatureGate = () => usePlanFeatureGate(Features.PickLists);
